module.exports = " <input class=\"account-search\" focus-if placeholder=\"search...\" name=\"search\" autocomplete=\"off\"\n    ng-model=\"$ctrl.model.name\" ng-blur=\"$ctrl.clear()\"\n    uib-typeahead=\"acc as acc.name for acc in $ctrl.accounts | filter:$viewValue | limitTo:20\"\n    typeahead-min-length=\"2\" typeahead-append-to-body=\"true\" typeahead-on-select=\"$ctrl.onSelect($item, $model, $label)\"\n    ng-disable=\"!$ctrl.accounts.length\" typeahead-editable=\"false\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/cn/accountedit.html
// module id = 33
// module chunks = 0